// src/icons/AffirmLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function AffirmLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    viewBox: "0 0 96 39",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y: "0px",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M4.5,33.5c0-1.8,2-2.4,5.6-2.8c0,2.4-1.6,4.3-3.9,4.3C5.1,35,4.5,34.4,4.5,33.5 M0.6,24.1l1.5,3.1 C3.4,26,5.5,25,7.4,25c1.8,0,2.8,0.6,2.8,1.8c0,0.8-0.7,1.2-1.9,1.4C3.7,28.8,0,30.1,0,33.7c0,2.9,2,4.6,5.2,4.6 c2.3,0,4.3-1.3,5.2-2.9v2.5h4.2V27.6c0-4.2-3-6-6.8-6C5.3,21.6,2.3,22.8,0.6,24.1",
        fill: "#090B0C"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M54.5,24.7V22h-4.2v15.8h4.5v-7.6c0-3.6,2.2-4.7,3.7-4.7c0.6,0,1.4,0.2,1.9,0.6l0.8-4.2 c-0.7-0.3-1.4-0.4-2-0.4C56.9,21.6,55.4,22.6,54.5,24.7",
        fill: "#090B0C"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M77.1,24.4c-0.9-1.8-2.7-2.8-4.9-2.8c-2.4,0-4,1.3-4.8,2.9V22h-4.4v15.8h4.5v-8.1c0-2.9,1.5-4.3,3-4.3 c1.3,0,2.5,0.8,2.5,3v9.5h4.5v-8.1c0-3,1.5-4.3,3-4.3c1.2,0,2.5,0.9,2.5,3v9.5h4.5V26.9c0-3.6-2.4-5.3-5.3-5.3 C79.8,21.6,78,23,77.1,24.4",
        fill: "#090B0C"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M30.7,20.9V22h-6.9v-1.6c0-2.1,1.2-2.7,2.2-2.7c0.6,0,1.4,0.1,2,0.5l1.4-3.2c-0.8-0.5-2.2-0.9-4-0.9 c-2.9,0-6.2,1.6-6.2,6.7V22h-2.6v3.5h2.6v12.3h4.5V25.5h6.9v12.3h4.5V25.5h4.1V22h-4.1v-1.6c0-2.1,1.2-2.7,2.2-2.7 c1.1,0,2,0.5,2,0.5l1.4-3.2c0,0-1.4-0.9-4-0.9C33.9,14.1,30.7,15.8,30.7,20.9",
        fill: "#090B0C"
      }),
      /* @__PURE__ */ jsx("rect", {
        className: "st5",
        fill: "#090B0C",
        height: 15.8,
        width: 4.5,
        x: 42,
        y: 22
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M42.1,19.4h4.4c2.6-8.1,11.3-15.2,21.7-15.2c12.7,0,23.6,9.6,23.6,24.6c0,3.4-0.4,6.4-1.3,9.1h4.3l0-0.1 c0.7-2.8,1.1-5.8,1.1-8.9C96,12,83.8,0,68.3,0C56.1,0,45.2,8.5,42.1,19.4",
        fill: "#329DD8"
      })
    ]
  });
}
export {
  AffirmLogo
};
//# sourceMappingURL=AffirmLogo.mjs.map